import React from "react";

const getRoleClassName = (role, index) => {
  const normalizedRole = String(role || "").toLowerCase();

  if (normalizedRole.includes("admin")) {
    return "team-page__role-badge team-page__role-badge--admin";
  }
  if (normalizedRole.includes("manager")) {
    return "team-page__role-badge team-page__role-badge--manager";
  }
  if (normalizedRole.includes("hr")) {
    return "team-page__role-badge team-page__role-badge--hr";
  }

  return `team-page__role-badge team-page__role-badge--neutral team-page__role-badge--${index}`;
};

const RoleBadges = ({ roles }) => {
  if (!roles.length) {
    return <span className="team-page__text-muted">N/A</span>;
  }

  return (
    <div className="team-page__role-list">
      {roles.map((role, index) => (
        <span className={getRoleClassName(role, index)} key={`${role}-${index}`}>
          {role}
        </span>
      ))}
    </div>
  );
};

export default RoleBadges;
